import PlantingProjectEditor from '../containers/PlantingProjectEditor/PlantingProjectEditor';

function PlantingProject() {
    return <PlantingProjectEditor />;
}

export default PlantingProject;
